import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private baseApiUrl = '';

  get baseUrl(): string {
    return this.baseApiUrl;
  }

  isProduction:boolean = true;
}